import moment from 'moment';
import type { Resolution886ItemList, Pagination } from '@/types';
import type { GetListResolution886ResponseDTO } from '@/core/dto/resolution-886-report';

export class GetListResolution886Mapper {
	constructor(private readonly data: GetListResolution886ResponseDTO) {}

	toDomain(): Pagination<Resolution886ItemList> {
		return {
			...this.data,
			rows: this.data.rows.map((value) => ({
				id: value.id,
				name: value.name,
				workstation_name: value.workstation_name,
				workers: value.worker_list,
				creation_date: value.created_at ? moment(value.created_at).format('L') : '-',
				review_date: value.review_date ? moment(value.review_date).format('L') : '-',
				last_review_consolidated: value.last_review_consolidated,
				organization_id: value.organization_id,
				company_id: value.company_id
			}))
		};
	}
}
